export { lensPostCommand, lensProfileCommand } from "./command";